<template>
  <!-- Al aparecer y en cada hover, unos destellos alrededor llaman la atención hacia contratar -->
  <div :class="['hire-highlight', { 'hire-highlight--compact': compact }]" @mouseenter="replay()">
    <!-- Cambiar la key vuelve a crear los destellos y reinicia la animación -->
    <span
      v-if="animate_on_load || highlight_key > 0"
      :key="highlight_key"
      :class="['hire-highlight__rays', { 'is-replay': highlight_key > 0 }]"
      aria-hidden="true"
    >
      <span v-for="ray in 6" :key="ray" :class="`hire-highlight__ray hire-highlight__ray--${ray}`" />
    </span>
    <b-button
      :class="['hire-button', { 'hire-button--compact': compact, 'hire-button--primary': !outline }]"
      :variant="outline ? 'outline-secondary' : 'none'"
      @click="$emit('click')"
    >
      <feather-icon icon="BriefcaseIcon" size="16" />
      <span>{{ label }}</span>
      <feather-icon v-if="!compact" icon="ChevronRightIcon" size="16" />
    </b-button>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  name: 'HireCreatorButton',
  components: {
    BButton,
  },
  props: {
    label: {
      type: String,
      default: 'Contratar Creador aquí',
    },
    // Versión del tamaño de los botones de acciones del header del perfil
    compact: {
      type: Boolean,
      default: false,
    },
    // Toma los colores de los botones outline-secondary de alrededor en lugar del morado
    outline: {
      type: Boolean,
      default: false,
    },
    // En false los destellos solo aparecen en hover
    animate_on_load: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      highlight_key: 0,
    };
  },
  methods: {
    replay() {
      this.highlight_key += 1;
    },
  },
};
</script>

<style scoped lang="scss">
.hire-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  min-height: 46px;
  padding: 0.6rem 1rem;
  border-radius: 10px;
  box-shadow: none;
  transition: background-color 0.15s, border-color 0.15s;

  &--primary {
    border: 1px solid #7367f0;
    background: #7367f0;
    color: white;

    &:hover,
    &:focus {
      color: white;
      border-color: #5e50ee;
      background: #5e50ee;
    }
  }

  &--compact {
    width: auto;
    min-height: 0;
    // Mismo alto que los botones outline-secondary .p-09 del header (el ícono es más alto que el texto)
    padding: 10px 14px;
    border-radius: 0.358rem;
    white-space: nowrap;
  }
}
.hire-highlight {
  position: relative;

  // Entre los botones del header hay poco espacio: destellos más cortos y pegados, con margen propio
  &--compact {
    display: inline-block;
    // Los botones vecinos son btn-group en línea con vertical-align: middle
    vertical-align: middle;
    margin-right: 22px;
  }
  &--compact &__ray {
    width: 8px;

    &--1 { left: -12px; top: -3px; --dx: -4px; --dy: -4px; }
    &--2 { left: -15px; --dx: -5px; }
    &--3 { left: -12px; bottom: -3px; --dx: -4px; --dy: 4px; }
    &--4 { right: -12px; top: -3px; --dx: 4px; --dy: -4px; }
    &--5 { right: -15px; --dx: 5px; }
    &--6 { right: -12px; bottom: -3px; --dx: 4px; --dy: 4px; }
  }

  &__ray {
    position: absolute;
    width: 12px;
    height: 3px;
    border-radius: 2px;
    background: #7367f0;
    opacity: 0;
    pointer-events: none;
    animation: hire-ray 1s ease-out 0.4s 2 both;

    // Tres destellos por lado: diagonal arriba, horizontal al centro y diagonal abajo
    &--1 { left: -18px; top: -4px; --r: 45deg; --dx: -6px; --dy: -6px; }
    &--2 { left: -24px; top: calc(50% - 1.5px); --r: 0deg; --dx: -8px; --dy: 0px; }
    &--3 { left: -18px; bottom: -4px; --r: -45deg; --dx: -6px; --dy: 6px; }
    &--4 { right: -18px; top: -4px; --r: -45deg; --dx: 6px; --dy: -6px; }
    &--5 { right: -24px; top: calc(50% - 1.5px); --r: 0deg; --dx: 8px; --dy: 0px; }
    &--6 { right: -18px; bottom: -4px; --r: 45deg; --dx: 6px; --dy: 6px; }
  }
  // En hover se dispara de inmediato y una sola vez
  &__rays.is-replay &__ray {
    animation-delay: 0s;
    animation-iteration-count: 1;
  }
}
@keyframes hire-ray {
  0% {
    opacity: 0;
    transform: translate(0, 0) rotate(var(--r)) scaleX(0.3);
  }
  35% {
    opacity: 1;
    transform: translate(calc(var(--dx) * 0.5), calc(var(--dy) * 0.5)) rotate(var(--r)) scaleX(1);
  }
  100% {
    opacity: 0;
    transform: translate(var(--dx), var(--dy)) rotate(var(--r)) scaleX(0.6);
  }
}
@media (prefers-reduced-motion: reduce) {
  .hire-highlight__ray {
    display: none;
  }
}
</style>
